<template>
  <!-- Rounded switch -->
  <div class="switch" @click="toggleIsOn">
    <input type="checkbox" id="do-switch" v-model="isOn">
    <p class="slider round" for="do-switch"></p>
  </div>
</template>

<script>
export default {
  props: {
    propOn: {
      default: true
    },
    allowChanges: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOn: this.propOn
    }
  },
  watch: {
    propOn (val, oldVal) {
      // if it changes from outside because of server response
      if (this.propOn !== this.isOn) {
        this.isOn = this.propOn
      }
    },
    isOn () {
      this.$emit('changed', this.isOn)
    }
  },
  methods: {
    toggleIsOn () {
      if (!this.allowChanges) {
        return
      }
      this.isOn = !this.isOn
    }
  }
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: calc(60px / 2);
  height: calc(34px / 2);
  top: 0px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
}

.slider:before {
  content: "";
  position: absolute;
  left: 1px;
  top: 1px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .25), 0 0 1px 0 rgba(0, 0, 0, .26);
  z-index: 2;
  height: 15px;
  width: 15px;
  border-radius: 6px;
  background-color: white;
  transition: transform .4s;
}

input:checked + .slider {
  background-color: #468AD7;
  box-shadow: 0 0 1px #468AD7;
}

input:checked + .slider:before {
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// AppToggle.vue?1a7fb736